import { Body, Box } from '@hover/blueprint';
import type { BoxProps } from '@hover/blueprint';
import React from 'react';
import { useParams } from 'react-router-dom';

import { Image } from 'src/modules/homeownerApp/components/ProjectShare/Image';
import { useGetProjectShareQuery } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const OriginalImage = ({ ...props }: BoxProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const { id } = useParams<{ id: string }>();
  const { data } = useGetProjectShareQuery({
    variables: { id },
  });
  const { aiDisplayImages } = data?.projectShare || {};

  const originalImage = aiDisplayImages?.[0]?.aiOriginalImage;
  const src = originalImage?.originalImagePath;
  return (
    <Box flexDirection="column" {...props}>
      <Image
        altText={t('images.myUploadAlt', {
          spaceType: originalImage?.spaceType,
        })}
        imagePath={src}
      />
      <Body fontWeight={700} marginBottom={0} marginTop="20px">
        {t('share.original')}
      </Body>
    </Box>
  );
};
